/**
 * Format a date string as a narrow relative time (e.g., "3 h", "2 d")
 * matching the notification center's timestamp style.
 *
 * - Under 7 days: narrow relative format via Intl.RelativeTimeFormat
 * - 7+ days: absolute date via Intl.DateTimeFormat (e.g., "3/18/2026")
 */
export function formatNarrowTimeAgo(dateStr: string): string {
  const date = new Date(dateStr);
  const diffMs = Date.now() - date.getTime();
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffDays >= 7) {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).format(date);
  }

  const rtf = new Intl.RelativeTimeFormat(undefined, {
    numeric: 'always',
    style: 'narrow',
  });

  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);

  if (diffMin < 1) return rtf.format(0, 'minute');
  if (diffMin < 60) return rtf.format(-diffMin, 'minute');
  if (diffHr < 24) return rtf.format(-diffHr, 'hour');
  return rtf.format(-diffDays, 'day');
}
